import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { PlayIcon, PauseIcon, FileTextIcon, SlidersIcon, RefreshCwIcon, UserIcon, MonitorIcon, SettingsIcon, XIcon } from 'lucide-react';
interface NavigationProps {
  isScrolling: boolean;
  toggleScrolling: () => void;
  inSyncMode?: boolean;
}
const Navigation: React.FC<NavigationProps> = ({
  isScrolling,
  toggleScrolling,
  inSyncMode = false
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  // Determine if we're on the teleprompter page
  const isOnTeleprompterPage = location.pathname === '/';
  // In sync mode, only show limited options
  if (inSyncMode) {
    return <div className="bg-gray-900 text-[#51a7fa] p-4 fixed bottom-0 left-0 right-0 z-10" data-id="element-20">
        <div className="flex justify-between items-center max-w-screen-lg mx-auto" data-id="element-21">
          <NavButton icon={<MonitorIcon size={20} data-id="element-23" />} label="Sync Mode" onClick={() => navigate('/')} isActive={isOnTeleprompterPage} data-id="element-22" />
          <NavLink to="/settings" icon={<SettingsIcon size={20} data-id="element-25" />} label="Settings" isActive={location.pathname === '/settings'} data-id="element-24" />
          <NavButton icon={<XIcon size={20} data-id="element-27" />} label="Exit Sync" onClick={() => navigate('/sync')} isActive={false} data-id="element-26" />
        </div>
      </div>;
  }
  return <div className="bg-gray-900 text-[#51a7fa] p-4 fixed bottom-0 left-0 right-0 z-10" data-id="element-28">
      <div className="flex justify-between items-center max-w-screen-lg mx-auto" data-id="element-29">
        {/* Always show Prompter button */}
        <NavButton icon={<MonitorIcon size={20} data-id="element-31" />} label="Prompter" onClick={() => navigate('/')} isActive={isOnTeleprompterPage} data-id="element-30" />
        <NavLink to="/scripts" icon={<FileTextIcon size={20} data-id="element-33" />} label="Scripts" isActive={location.pathname === '/scripts'} data-id="element-32" />
        <NavLink to="/controller" icon={<SlidersIcon size={20} data-id="element-35" />} label="Controller" isActive={location.pathname === '/controller'} data-id="element-34" />
        <NavLink to="/settings" icon={<SettingsIcon size={20} data-id="element-37" />} label="Settings" isActive={location.pathname === '/settings'} data-id="element-36" />
        <NavLink to="/account" icon={<UserIcon size={20} data-id="element-39" />} label="Account" isActive={location.pathname === '/account'} data-id="element-38" />
      </div>
    </div>;
};
interface NavLinkProps {
  to: string;
  icon: React.ReactNode;
  label: string;
  isActive: boolean;
}
const NavLink: React.FC<NavLinkProps> = ({
  to,
  icon,
  label,
  isActive
}) => {
  return <Link to={to} className={`flex flex-col items-center ${isActive ? 'text-white' : 'text-[#51a7fa]'}`} data-id="element-40">
      {icon}
      <span className="text-xs mt-1" data-id="element-41">{label}</span>
    </Link>;
};
interface NavButtonProps {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  isActive: boolean;
}
const NavButton: React.FC<NavButtonProps> = ({
  icon,
  label,
  onClick,
  isActive
}) => {
  return <button onClick={onClick} className={`flex flex-col items-center ${isActive ? 'text-white' : 'text-[#51a7fa]'}`} data-id="element-42">
      {icon}
      <span className="text-xs mt-1" data-id="element-43">{label}</span>
    </button>;
};
export default Navigation;